import type { ClientAccessDenial } from "@repo/shared/types";
import { Lock } from "lucide-react";
import { Link } from "react-router";
import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/ui/empty-state";
import { useUserLanguage } from "@/lib/i18n";
import { clientAccessDenialText } from "./client-access-denial-text";

/** QL-380 — replaces the endless spinner when a client (or its flow) is restricted. Never shows the client's name. */
export function ClientAccessDeniedCard({ denial }: { denial: ClientAccessDenial }) {
  const { userLanguage } = useUserLanguage();
  const text = clientAccessDenialText(denial, userLanguage);
  return (
    <EmptyState
      action={
        <Button asChild variant="outline">
          <Link to="/clients">{text.back}</Link>
        </Button>
      }
    >
      <Lock className="mx-auto mb-3 h-8 w-8" />
      <span className="block font-medium text-foreground">{text.title}</span>
      <span className="mt-1 block">{text.message}</span>
    </EmptyState>
  );
}
